import { Typography, Grid, Container, Box } from "@mui/material";

const AboutUsSection = () => (
    <Container
        id="about"
        sx={{
            padding: { xs: "4rem 2rem", md: "4rem 0" },
            textAlign: "center",
        }}
    >
        <Typography variant="h2" marginBottom={2.5}>ABOUT US</Typography>
        <Typography variant="h3">
            Your Trusted Partner in Construction
        </Typography>
        <Typography variant="h3"> Management </Typography>
        <Box display="flex" justifyContent="center">
            <Typography variant="body1" marginBottom={10} marginTop={5} width={'80%'} sx={{
            }}>
                Welcome to GC Builders, your trusted partner in construction management. In the construction industry, where a general contractor plays a crucial role in overseeing projects to ensure they are completed safely, on time, and according to specifications. That is exactly what we excel at.
            </Typography>
        </Box>
        <Grid container spacing={4} justifyContent="center">
            {[{
                title: "ADMINISTRATION",
                text: (
                    <>
                        We take on the critical responsibility of managing the administrative aspects of your construction project. This involves <strong>meticulously developing and maintaining the project budget</strong>, closely tracking expenses, and ensuring that the project remains within financial limits.
                    </>
                ),
                image: "url('/img/administration.png')"
            }, {
                title: "PROJECT MANAGEMENT",
                text: (
                    <>
                        We handle the scheduling and coordination of various subcontractors, <strong>manage contracts, and ensure compliance with all relevant regulatory requirements</strong>. By overseeing these administrative tasks, we ensure that your project is completed on time, within budget, and to your utmost satisfaction.
                    </>
                ),
                image: "url('/img/management.png')"
            }, {
                title: "CHIEF BUILDERS",
                text: (
                    <>
                        As general contractors, <strong>we manage chief builders by coordinating their work</strong>, ensuring quality and safety standards, and keeping tasks on schedule and within budget. This ensures seamless execution of your construction project.
                    </>
                ),
                image: "url('/img/chief.png')"
            }].map((item, index) => (
                <Grid item xs={12} md={4} key={index}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Box
                            style={{
                                height: "320px",
                                width: "320px",
                                backgroundImage: item.image,
                                backgroundSize: "cover",
                                backgroundPosition: "center"
                            }}
                        />
                        <Typography
                            variant="h3"
                            fontSize={'25px'}
                            marginY={3}
                        >
                            {item.title}
                        </Typography>
                        <Typography
                            variant="body2"
                            fontSize={"18px"}
                            style={{
                                textAlign: "justify",
                                wordBreak: "break-word",
                                hyphens: "auto",
                                width: "100%"
                            }}
                        >
                            {item.text}
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    </Container>
);

export default AboutUsSection;